import {BuiltInControlTypes} from '../../../constants/BuiltInControlTypes';
import {TextBuiltInControl} from '../TextBuiltInControl';

/**
 * @description base class including text line spacing modifications logic
 */
export abstract class TextLineSpacingBuiltInControl extends TextBuiltInControl {
  public getParentControlId(): string {
    return BuiltInControlTypes.GENERAL.TEXT_LINE_SPACING;
  }
}
